// extracted by mini-css-extract-plugin
module.exports = {"lottie":"frame-container_lottie__2yYIJ"};